import gatCalcAvgReportTime from "@custom/rtk-apis/analytics/getCalcAvgReportTime";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getCalcAvgReportTimeSlice = createSlice({
  name: "getCalcAvgReportTimeSlice",
  initialState,
  reducers: {
    clearCalcAvgReportTime: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(gatCalcAvgReportTime.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(gatCalcAvgReportTime.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload;
        state.msg = payload.message;
      })
      .addCase(gatCalcAvgReportTime.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getCalcAvgReportTimeSlice.reducer;
export const { clearCalcAvgReportTime } = getCalcAvgReportTimeSlice.actions;
